var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":"pageTour","steps":_vm.steps[_vm.$route.path]},scopedSlots:_vm._u([{key:"default",fn:function(tour){return _c('tour-guide-module',{attrs:{"tour":tour,"steps":_vm.steps,"set-as-visualized":_vm.stopTourGuide}})}}])})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }